// extracted by mini-css-extract-plugin
export var equalColumn = "_gd-0";